export type AppErrorKind =
  | 'config'
  | 'auth'
  | 'session'
  | 'network'
  | 'not_found'
  | 'runtime'
  | 'unknown';

export type AppErrorActionId = 'retry' | 'home' | 'portal' | 'settings';

export interface AppErrorAction {
  id: AppErrorActionId;
  label: string;
  primary?: boolean;
}

export interface AppErrorDetails {
  kind: AppErrorKind;
  title: string;
  message: string;
  detail?: string;
  statusCode?: number;
  actions?: AppErrorAction[];
}

export const APP_ERROR_STORAGE_KEY = 'gantt-planner:appError';

export const DEFAULT_APP_ERROR: AppErrorDetails = {
  kind: 'unknown',
  title: 'Something went wrong',
  message: 'An unexpected error occurred. Try again or return to the dashboard.',
};

export const NOT_FOUND_ERROR: AppErrorDetails = {
  kind: 'not_found',
  title: 'Page not found',
  message: 'The page you requested does not exist or may have been moved.',
  statusCode: 404,
};
